export const IS_LOADING_FAQS = "IS_LOADING_FAQS";
export const FAQS_DATA_SUCCESS = "FAQS_DATA_SUCCESS";
export const FAQS_DATA_FAILED = "FAQS_DATA_FAILED";

export const IS_LOADING_SAVE_FAQS = "IS_LOADING_SAVE_FAQS";
export const SAVE_FAQS_DATA_SUCCESS = "SAVE_FAQS_DATA_SUCCESS";
export const SAVE_FAQS_DATA_FAILED = "SAVE_FAQS_DATA_FAILED";


